import React from "react";
import { useWishlist } from "../context/WishlistContext";
import "./Collection.css";

const Collection = () => {
  const whatsappNumber = "919727983039";
  const { toggleWishlist, isInWishlist } = useWishlist();

  const featuredProduct = {
    id: 1,
    title: "MultiFct B-7000 Multi-Purpose Adhesive (50ml Single Pack)",
    category: "Glue",
    price: 250,
    oldPrice: 500,
    discount: "50% off",
    rating: "4.9",
    reviews: 310,
    image: "/images/b7000-specs.jpg",
    description: "A precision industrial adhesive with needle applicator nozzle, waterproof flexible bond, and anti-clogging pin cap.",
  };

  const isFavorited = isInWishlist(featuredProduct.id);

  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello, I am interested in the MultiFct B-7000 Multi-Purpose Adhesive."
    );

    window.open(
      `https://wa.me/${whatsappNumber}?text=${message}`,
      "_blank"
    );
  };

  return (
    <section className="hm-collection">

      {/* Section Heading */}
      <div className="hm-collection-header">
        <span className="hm-collection-label">
          THE COLLECTION
        </span>

        <h2>
          Simple storage, beautifully
          <br />
          sorted
        </h2>

        <p>
          Organizers designed to make wardrobes, shelves and daily
          routines feel lighter.
        </p>
      </div>


      {/* Product Card */}
      <div className="hm-product-card-main">

        {/* Product Image Area */}
        <div className="hm-product-image-area">

          <span className="hm-bestseller">
            Bestseller
          </span>

          <button
            className={`hm-product-wishlist ${isFavorited ? "active" : ""}`}
            onClick={() => toggleWishlist(featuredProduct)}
            aria-label="Add to wishlist"
          >
            <svg
              viewBox="0 0 24 24"
              fill={isFavorited ? "#e03131" : "none"}
              stroke={isFavorited ? "#e03131" : "currentColor"}
              strokeWidth="1.8"
            >
              <path d="M20.8 8.8c0 5.5-8.8 10.2-8.8 10.2S3.2 14.3 3.2 8.8A4.8 4.8 0 0 1 8 4a5.2 5.2 0 0 1 4 2.1A5.2 5.2 0 0 1 16 4a4.8 4.8 0 0 1 4.8 4.8Z" />
            </svg>
          </button>

          <img
            src="/images/b7000-specs.jpg"
            alt="MultiFct B-7000 Adhesive"
            className="hm-collection-product-image"
          />

        </div>


        {/* Product Details */}
        <div className="hm-product-details">

          <span className="hm-product-type">
            MULTI-ANGLE PRODUCT VIEW
          </span>

          <h3>
            MultiFct B-7000 Multi-Purpose Adhesive
          </h3>


          {/* Rating */}
          <div className="hm-product-rating">

            <span className="hm-stars">
              ★★★★★
            </span>

            <span className="hm-rating-number">
              4.9 (310)
            </span>

          </div>


          <p className="hm-product-description">
            A precision industrial adhesive with needle applicator nozzle,
            waterproof flexible bond, and anti-clogging pin cap.
          </p>


          {/* Price */}
          <div className="hm-product-price">

            <span className="hm-current-price">
              ₹250
            </span>

            <span className="hm-old-price">
              ₹500
            </span>

            <span className="hm-discount">
              50% off
            </span>

          </div>


          {/* WhatsApp */}
          <button
            className="hm-enquire-btn"
            onClick={handleWhatsApp}
          >
            <svg
              viewBox="0 0 24 24"
              className="hm-enquire-icon"
            >
              <path
                fill="currentColor"
                d="M20.5 3.5A11.7 11.7 0 0 0 12.1 0C5.6 0 .3 5.3.3 11.8c0 2.1.5 4.1 1.6 5.9L.2 24l6.4-1.7a11.8 11.8 0 0 0 5.5 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.1 21.7c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4a9.8 9.8 0 1 1 8.5 4.7Zm5.4-7.4c-.3-.2-1.7-.9-2-.9-.3-.1-.5-.2-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.5-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.1-1.4-.1-.1-.3-.2-.6-.4Z"
              />
            </svg>

            Enquire on WhatsApp
          </button>

        </div>
      </div>

    </section>
  );
};

export default Collection;